export const homeObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDes: true,
    topLine: 'PrimaFresh ',
    headline: 'Råvaror med kvalitet i varje detalj',
    headline2: 'Traditionellt hantverk. Exceptionell finish.',
    description: 'Vi levererar noggrant utvalda frukter och grönsaker till restauranger, hotell, caféer och storkök som ställer höga krav på kvalitet. Med fokus på färska råvaror, jämn kvalitet och pålitliga leveranser ser vi till att våra kunder alltid får det bästa. För oss handlar det om mer än att leverera råvaror – det handlar om service, flexibilitet och att förstå varje kunds behov.',
    imgStart: false,
    img: require('../../AssetsForAbout/kiwi.png'),
    alt: 'Car',
    dark: true,
    primary: true,
    darkText: false,
}